import { Rect } from "react-konva";
import type { RectangleGeometry } from "@/types/canvasTypes";

interface Props {
  /**
   * In-flight selection rectangle in canvas coordinates. Null when no
   * box-select drag is active.
   */
  box: RectangleGeometry | null;
}

/**
 * Thin component: just renders the in-flight selection rect. Pointer
 * handling lives in Canvas.tsx so the same state can decide between
 * box-select (drag on Stage) vs background-pan (alt or middle-click)
 * vs no-op (drag on a rect or other interactive node).
 */
const CanvasSelectionLayer = ({ box }: Props) => {
  if (!box) return null;
  return (
    <Rect
      x={box.x}
      y={box.y}
      width={box.width}
      height={box.height}
      stroke="#3b82f6"
      strokeWidth={1}
      dash={[4, 3]}
      fill="rgba(59, 130, 246, 0.08)"
      listening={false}
    />
  );
};

export default CanvasSelectionLayer;
